module.exports = __webpack_public_path__ + "img/30-indicadores-osm-hub.13bc5331.png";